export default "__VITE_ASSET__C08tU8H9__"